<!--
 * @Description: 网络课程学习任务 修改
 * @Author: PF
 * @Date: 2025-10-29 15:50:22
 * @LastEditors: PF
 * @LastEditTime: 2025-12-24 11:22:09
-->
<template>
  <div>
    <el-dialog class="w500 h500" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="110px">
        <el-form-item label="学期" prop="xqid">
          <el-tag v-if="ruleForm.xqmc">{{ ruleForm.xqmc }}</el-tag>
        </el-form-item>
        <el-form-item label="课程计划" prop="wljxjhid">
          <el-tag v-if="ruleForm.kcmc">{{ ruleForm.kcmc }}</el-tag>
        </el-form-item>
        <el-form-item label="学习班级">
          <el-tag v-for="item in bjData" :key="item" style="margin: 5px 10px 5px 0;">{{ item.bjmc }}</el-tag>
        </el-form-item>
        <el-form-item label="网络课程" prop="wlkcid" :rules="[{ required: true, message: '必填项' }]">
          <el-button type="primary" size="small" class="mr10" v-if="!ruleForm.xfzt" @click="openKeChengDanTiao = true">选择</el-button>
          <el-tag v-if="ruleForm.wlkcmc">{{ ruleForm.wlkcmc }}</el-tag>
        </el-form-item>
        <el-form-item label="测试试卷">
          <el-button type="primary" size="small" class="mr5" @click="openShiJuanDuoTiao = true">选择</el-button>
          <el-tag v-for="(item, index) in csData" :key="item" style="margin: 5px;" closable @close="yiChu(index)">{{ item.sjmc }}</el-tag>
        </el-form-item>
        <el-form-item label="考试试卷" v-if="ruleForm.sfks">
          <el-button type="primary" size="small" class="mr10" @click="openShiJuanDanTiao = true">选择</el-button>
          <el-tag v-if="kaoShiData.sjmc">{{ kaoShiData.sjmc }}</el-tag>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <netkechengdantiao v-if="openKeChengDanTiao" v-model:openDanTiao="openKeChengDanTiao" @ReturnData="ReturnKeChengData" />
  <shijuanduotiao v-if="openShiJuanDuoTiao" v-model:openDuoTiao="openShiJuanDuoTiao" :row="{ids:csidData}" @ReturnData="ReturnCeShiData" />
  <shijuandantiao v-if="openShiJuanDanTiao" v-model:openDanTiao="openShiJuanDanTiao" @ReturnData="ReturnKaoShiData" />
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  loadData,
  submitEditForm,
  closeWindow,
  loadSelect
} from '@/api/common.js'
import netkechengdantiao from '@/components/chazhaodaihui/netkechengdantiao.vue'
import shijuandantiao from '@/components/chazhaodaihui/shijuandantiao.vue'
import shijuanduotiao from '@/components/chazhaodaihui/shijuanduotiao.vue'
const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])

const ruleFormRef = ref(null)
const ruleForm = ref({})

// 网络课程 单选 BEGIN
const openKeChengDanTiao = ref(false)
const ReturnKeChengData = (data) => {
  ruleForm.value.wlkcid = data.id
  ruleForm.value.wlkcmc = data.wlkcmc
}
// 网络课程 单选 END 

// 测试 多选 BEGIN
const openShiJuanDuoTiao = ref(false)
const csData = ref([])
const csidData = ref([])
const ReturnCeShiData = (data) => {
  csData.value = data || []
  csidData.value = data.map((item) => item.id)
}
const yiChu = (index) => {
  csData.value.splice(index, 1)
  csidData.value.splice(index, 1)
}
// 测试 多选 END

// 考试 单选 BEGIN
const kaoShiData = ref({})
const openShiJuanDanTiao = ref(false)
const ReturnKaoShiData = (data) => {
  kaoShiData.value.id = data.id
  kaoShiData.value.sjmc = data.sjmc
}
// 考试 单选 END 

// 加载 网络教学计划 下拉框
const wljxjhData = ref([])
const initJiaoXueJiHua = () => {
  loadSelect({
    url: '/api/v2/wangluojiaoxue/jihua/list',
    data: wljxjhData,
    parms: {xqid: ruleForm.value.xqid, order: 'CreatedTime', sort: 'desc' }
  })
}
const bjData = ref([])
const initBanJi = () => {
  const info = wljxjhData.value.find(item => item.id === ruleForm.value.wljxjhid)
  bjData.value = info ? info.bjList : ''
}

// 加载 学期 下拉框
const xqData = ref()
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadSelect({ url: '/api/v2/pdp/xueqi/list', data: xqData, order: 'sx', sort: 'asc' })
      loadData({
        url: '/api/v2/wangluojiaoxue/renwu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          initJiaoXueJiHua()
          bjData.value = res.data.bjList
          csData.value = []
          res.data.shijuanVOList.forEach(element => {
            // 试卷类型:1-考试 2-测试
            switch (element.sjlx) {
              case 1:
                kaoShiData.value = {id: element.sjid, sjmc: element.sjmc}
                break;
              case 2:
                csData.value.push({id: element.sjid, sjmc: element.sjmc})
                csidData.value.push(element.sjid)
                break;
            }
          });
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  ruleForm.value.shiJuanList = csData.value.map(item => ({
    menuId: sessionStorage.getItem('menuId'),
    sjid: item.id,
    sjlx: 2 // 试卷类型:1-考试 2-测试
  }))
  ruleForm.value.shiJuanList.push({
    menuId: sessionStorage.getItem('menuId'),
    sjid: kaoShiData.value.id,
    sjlx: 1 // 试卷类型:1-考试 2-测试
  })
  submitEditForm({
    url: '/api/v2/wangluojiaoxue/renwu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>

<style scoped lang="less">
.container {
  display: flex;
  .zuo {
    width: 440px;
  }

  .zhong {
    background-color: #DCDFE6;
    margin: 0 30px;
    width: 1px;
  }

  .you {
    width: 478px;
    line-height: 25px;
    .you-tit {
      font-size: 16px;
      font-weight:700;
      color: #606266;
    }
    .you-fu-tit {
      font-size: 14px;
      font-weight:700;
      margin: 8px 0 8px 20px;
      color: #606266;
    }
    :deep(.el-radio-group) {
      height: auto;
    }
  }
}
</style>
